/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

export const UNUSED_CATEGORY_KEYS = {
	// links: true,
};
